import React from 'react';

import { Button, Text } from 'reaxl';

export default () => (
    <>
        <Button bsStyle="text">Apply for Financing</Button>
        <Text> to see all available lenders from this dealer and compare rates on your next vehicle.</Text>
    </>
);
